import { render, staticRenderFns } from "./ForDoctorsByDoctors.vue?vue&type=template&id=199621cc&"
import script from "./ForDoctorsByDoctors.vue?vue&type=script&lang=js&"
export * from "./ForDoctorsByDoctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports